<template>
  <div class="bg-light2 py-4">
    <div class="container d-flex justify-content-between">
      <div class="text pt-2 pr-2">
        <span v-html="$t('PAGE_PROFILE_banner')" />
        <img
          src="../assets/folded-hands.svg"
          style="width: 20px; margin-top: -5px;"
          class="ml-1"
        />
      </div>

      <b-button
        variant="outline-grey"
        class="button"
        @click="
          $router.push({ name: 'profile_index', params: { tabIndex: 1 } })
        "
        >{{ $t('PAGE_PROFILE_banner_button') }}</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'completeProfileBanner',
};
</script>
<style lang="scss" scoped>
.button {
  min-width: 10rem;
}
.text {
  font-size: 1.1rem;
  line-height: 1.5rem;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/CompleteProfileBanner.vue